module.exports = __webpack_public_path__ + "img/events.eda8551c.svg";